import React, { useContext, useEffect } from "react";
import Header from "./../layouts/header";
import Footer from "./../layouts/footer";
import Spinner from "react-bootstrap/Spinner";
import InputMask from "react-input-mask";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";
import PartnershipImage from "./../../assets/images/partnership-image.png";
import { useNavigate } from "react-router-dom";
import { MessageContext } from "../../Context/message-context";
import usePartnerForm from "./partners/usePartnerForm";
import {
  REGISTER_AS_OPTIONS,
  YES_NO_OPTIONS,
  EMPLOYEE_COUNT_OPTIONS,
  BUSINESS_VINTAGE_OPTIONS,
} from "./partners/partner.constants";

const fieldClass = (hasError) => (hasError ? "form-control error" : "form-control");
const fileFieldClass = (hasError) =>
  hasError ? "partner-file form-control error" : "partner-file form-control";

export default function Partner() {
  const { setMessage } = useContext(MessageContext);
  const navigate = useNavigate();

  const {
    formData,
    errors,
    files,
    fileErrors,
    panInvalid,
    gstInvalid,
    ifscMessage,
    accountMessage,
    isSubmitting,
    isGstExempt,
    handlePhoneChange,
    handleEmailChange,
    handlePanChange,
    handleGstChange,
    handleChange,
    handlePinCodeLookup,
    handleIfscChange,
    handleIfscBlur,
    handleFileChange,
    handleVerifyAndSubmit,
  } = usePartnerForm({
    onSuccess: (message) => {
      setMessage(message);
      navigate("/thank-you");
    },
    onSubmitError: (message) => {
      Swal.fire({ title: "", text: message, icon: "error", confirmButtonText: "Got It" });
    },
  });

  useEffect(() => {
    localStorage.removeItem("isAuthenticate");
    localStorage.removeItem("user_id");
  }, []);

  useEffect(() => {
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);

  return (
    <>
      <Helmet>
        <title>Become a FinLab Partner - Grow Your Business with Financial Products</title>
        <meta
          name="description"
          content="Become a partner with FinLab to offer exclusive financial products and services to your clients. Join us today and grow your business."
        />
        <meta
          name="keywords"
          content="financial partnerships, business partnerships, partner with FinLab, financial services, business growth"
        />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "FinLab",
              "url": "https://finlab.one/partner",
              "description": "Become a business partner with FinLab to provide financial products and services to your clients.",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+919837010594",
                "contactType": "Business Partnership"
              },
              "sameAs": ["https://www.linkedin.com/company/finlab"]
            }
          `}
        </script>
      </Helmet>

      <div className="hero_area">
        <Header navigateMenu={() => {}} />
        <div className="partner-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-4">
                <div className="partner-left">
                  <div className="eagertoForge partner-center">
                    <h2>RIGHT PARTNERSHIPS CAN GO A LONG WAY!</h2>
                    <h2 style={{ color: "#02BD64" }}>Inviting applications now...</h2>
                  </div>
                  <div className="recommend-img">
                    <img
                      src={PartnershipImage}
                      className="partner-center recommetnImgsd"
                      alt="ReferImage"
                    />
                  </div>
                </div>
              </div>

              <div className="col-lg-6 col-md-8">
                <div className="form-wrap">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Want to register as</label>
                        <select
                          name="registerAs"
                          className={fieldClass(errors.registerAs)}
                          onChange={handleChange}
                          value={formData.registerAs}
                        >
                          <option value="">Select</option>
                          {REGISTER_AS_OPTIONS.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                        {errors.registerAs && <small className="alertbox">Please fill here</small>}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="phoneNumber">Mobile Number</label>
                        <InputMask
                          mask="999 999 9999"
                          type="tel"
                          maskChar=""
                          name="phoneNumber"
                          placeholder="Enter Mobile Number"
                          className={fieldClass(errors.phoneNumber)}
                          value={formData.phoneNumber}
                          onChange={handlePhoneChange}
                        />
                        {errors.phoneNumber && <small className="alertbox">Please fill here</small>}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="email">Email ID</label>
                        <input
                          type="email"
                          name="email"
                          id="email"
                          placeholder="Enter Email ID"
                          className={fieldClass(errors.email)}
                          value={formData.email}
                          onChange={handleEmailChange}
                        />
                        {errors.email && <small className="alertbox">Please fill here</small>}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>
                          PAN # (<small>company or Individual</small>)
                        </label>
                        <InputMask
                          mask="aaaaa9999a"
                          maskChar=""
                          className={fieldClass(errors.panNumber)}
                          placeholder="DFRSC3456F"
                          value={formData.panNumber}
                          onChange={handlePanChange}
                        />
                        {errors.panNumber ? (
                          <small className="alertbox">Please fill here</small>
                        ) : (
                          panInvalid && <small className="alertbox">Invalid PAN number</small>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>GST</label>
                        <InputMask
                          mask="99aaaaa9999a9a*"
                          maskChar=""
                          className={fieldClass(errors.gst)}
                          placeholder="22AAAAA0000A1Z5"
                          value={formData.gst}
                          onChange={handleGstChange}
                        />
                        {errors.gst ? (
                          <small className="alertbox">Please fill here</small>
                        ) : (
                          gstInvalid && <small className="alertbox">Invalid GST number</small>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Name as per PAN</label>
                        <input
                          type="text"
                          name="panName"
                          className={fieldClass(errors.panName)}
                          placeholder="Name as per PAN"
                          value={formData.panName}
                          onChange={handleChange}
                        />
                        {errors.panName && <small className="alertbox">Please fill here</small>}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Pin code</label>
                        <InputMask
                          mask="999999"
                          type="tel"
                          maskChar=""
                          name="pinCode"
                          className={fieldClass(errors.pinCode)}
                          placeholder="Enter Pincode"
                          value={formData.pinCode}
                          onChange={handleChange}
                          onKeyUp={handlePinCodeLookup}
                        />
                        {errors.pinCode && <small className="alertbox">Please fill here</small>}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Street</label>
                        <textarea
                          name="streetAddress"
                          className={fieldClass(errors.streetAddress)}
                          placeholder="Enter your street..."
                          value={formData.streetAddress}
                          onChange={handleChange}
                        ></textarea>
                        {errors.streetAddress && <small className="alertbox">Please fill here</small>}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Landmark</label>
                        <textarea
                          name="landmark"
                          className={fieldClass(errors.landmark)}
                          placeholder="Enter your landmark..."
                          value={formData.landmark}
                          onChange={handleChange}
                        ></textarea>
                        {errors.landmark && <small className="alertbox">Please fill here</small>}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>City</label>
                        <textarea
                          name="city"
                          className={fieldClass(errors.city)}
                          placeholder="Enter your city..."
                          value={formData.city}
                          onChange={handleChange}
                        ></textarea>
                        {errors.city && <small className="alertbox">Please fill here</small>}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>State</label>
                        <textarea
                          name="state"
                          className={fieldClass(errors.state)}
                          placeholder="Enter your state..."
                          value={formData.state}
                          onChange={handleChange}
                        ></textarea>
                        {errors.state && <small className="alertbox">Please fill here</small>}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Is your company registered</label>
                        <select
                          name="companyRegister"
                          className={fieldClass(errors.companyRegister)}
                          onChange={handleChange}
                          value={formData.companyRegister}
                        >
                          <option value="">Select</option>
                          {YES_NO_OPTIONS.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                        {errors.companyRegister && (
                          <small className="alertbox">Please fill here</small>
                        )}
                      </div>
                    </div>

                    {formData.companyRegister === "Yes" && (
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Upload Registration proof</label>
                          <input
                            type="file"
                            accept="image/png, image/jpeg, image/gif"
                            className={fileFieldClass(fileErrors.registerUpload)}
                            onChange={handleFileChange("registerUpload")}
                          />
                          <span className="vrtext message">* File Format: JPEG, PNG, PDF</span>
                          {fileErrors.registerUpload && (
                            <small className="alertbox">{fileErrors.registerUpload}</small>
                          )}
                        </div>
                      </div>
                    )}

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Do you have office setup</label>
                        <select
                          name="officeSetup"
                          className={fieldClass(errors.officeSetup)}
                          onChange={handleChange}
                          value={formData.officeSetup}
                        >
                          <option value="">Select</option>
                          {YES_NO_OPTIONS.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                        {errors.officeSetup && <small className="alertbox">Please fill here</small>}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>No of employees</label>
                        <select
                          name="employeeNumber"
                          className={fieldClass(errors.employeeNumber)}
                          onChange={handleChange}
                          value={formData.employeeNumber}
                        >
                          <option value="">Select</option>
                          {EMPLOYEE_COUNT_OPTIONS.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                        {errors.employeeNumber && (
                          <small className="alertbox">Please fill here</small>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Business Vintage</label>
                        <select
                          name="businessVintage"
                          className={fieldClass(errors.businessVintage)}
                          onChange={handleChange}
                          value={formData.businessVintage}
                        >
                          <option value="">Select</option>
                          {BUSINESS_VINTAGE_OPTIONS.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                        {errors.businessVintage && (
                          <small className="alertbox">Please fill here</small>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <h5>Bank Details</h5>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Account Holder Name</label>
                        <input
                          type="text"
                          name="bankName"
                          className={fieldClass(errors.bankName)}
                          placeholder="Enter Account Holder Name"
                          onChange={handleChange}
                          value={formData.bankName}
                        />
                        {errors.bankName ? (
                          <small className="alertbox">Please fill here</small>
                        ) : (
                          accountMessage && <small className="alertbox">{accountMessage}</small>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Account No.</label>
                        <input
                          type="text"
                          name="account"
                          className={fieldClass(errors.account)}
                          placeholder="Enter Account No."
                          onChange={handleChange}
                          value={formData.account}
                        />
                        {errors.account && <small className="alertbox">Please fill here</small>}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>IFSC</label>
                        <input
                          type="text"
                          className={fieldClass(!!ifscMessage)}
                          placeholder="Enter IFSC"
                          value={formData.ifsc}
                          onChange={handleIfscChange}
                          onBlur={handleIfscBlur}
                        />
                        {ifscMessage && <small className="alertbox">{ifscMessage}</small>}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Branch</label>
                        <input
                          type="text"
                          name="branch"
                          className={fieldClass(errors.branch)}
                          placeholder="Your Branch"
                          value={formData.branch}
                          onChange={handleChange}
                        />
                        {errors.branch && <small className="alertbox">Please fill here</small>}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Upload Cancelled check</label>
                        <input
                          type="file"
                          accept="image/png, image/jpeg"
                          className={fileFieldClass(fileErrors.cancelledCheck)}
                          onChange={handleFileChange("cancelledCheck")}
                        />
                        <span className="vrtext message">* File Format: JPEG, PNG</span>
                        {fileErrors.cancelledCheck && (
                          <small className="alertbox">{fileErrors.cancelledCheck}</small>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Upload KYC</label>
                        <input
                          type="file"
                          accept=".pdf"
                          className={fileFieldClass(fileErrors.kyc)}
                          onChange={handleFileChange("kyc")}
                        />
                        <span className="vrtext message">* File Format: PDF</span>
                        {fileErrors.kyc && <small className="alertbox">{fileErrors.kyc}</small>}
                      </div>
                    </div>

                    {!isGstExempt && (
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Upload GST</label>
                          <input
                            type="file"
                            accept=".pdf"
                            className={fileFieldClass(fileErrors.uploadGst)}
                            onChange={handleFileChange("uploadGst")}
                          />
                          <span className="vrtext message">* File Format: PDF</span>
                          {fileErrors.uploadGst && (
                            <small className="alertbox">{fileErrors.uploadGst}</small>
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="row">
                    <div className="col-md-6 m-auto join-now">
                      <button
                        type="submit"
                        id="submit"
                        className="btn btn-partner"
                        onClick={handleVerifyAndSubmit}
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />{" "}
                            Please Wait...
                          </>
                        ) : (
                          "Join Now"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
      <ToastContainer />
    </>
  );
}
